// @/components/reusable/badge.jsx
// V2 Badge Component with size variants

import React from "react";
import clsx from "clsx";

// ============================================================================
// COLOR VARIANTS
// ============================================================================

const colors = {
  red: "bg-red-500/15 text-red-700",
  amber: "bg-amber-100 text-orange-600",
  orange: "bg-orange-100 text-orange-600",
  yellow: "bg-orange-400/20 text-orange-600",
  lime: "bg-lime-400/20 text-lime-700",
  green: "bg-emerald-500/15 text-teal-600",
  emerald: "bg-emerald-500/15 text-teal-600",
  teal: "bg-emerald-500/15 text-teal-600",
  cyan: "bg-cyan-400/20 text-cyan-700",
  sky: "bg-sky-500/15 text-sky-700",
  blue: "bg-primary/10 text-primary",
  indigo: "bg-indigo-500/15 text-indigo-700",
  violet: "bg-violet-500/15 text-violet-700",
  purple: "bg-purple-500/15 text-purple-700",
  fuchsia: "bg-fuchsia-400/15 text-fuchsia-700",
  pink: "bg-pink-400/15 text-pink-700",
  rose: "bg-rose-400/10 text-rose-600",
  zinc: "bg-zinc-600/5 text-zinc-700",
  white: "bg-white text-zinc-900 ring-1 ring-zinc-100",
  black: "bg-zinc-900 text-zinc-100",
};

// ============================================================================
// SIZE VARIANTS
// ============================================================================

const sizes = {
  sm: "px-1.5 py-px text-[10px]/4 font-semibold tracking-tight",
  md: "px-2.5 py-px text-[12px]/6 font-semibold tracking-tighter",
  lg: "px-2.5 py-0.5 text-xs/5 font-bold tracking-tighter",
  icon: "p-1.5 rounded-full",
};

// ============================================================================
// BADGE COMPONENT
// ============================================================================

/**
 * Badge - V2 badge with size variants
 *
 * @param {string} color - Color variant (default: "zinc")
 * @param {string} size - Size variant: "sm" | "md" | "lg" (default: "md")
 * @param {string} className - Additional classes
 */
const Badge = ({ color = "zinc", size = "md", className, ...props }) => {
  return (
    <span
      {...props}
      className={clsx(
        // Base styles
        "inline-flex items-center rounded-lg font-fono",
        // Size variant
        sizes[size],
        // Color variant
        colors[color],
        // Custom classes
        className
      )}
    />
  );
};

export { Badge };
export default Badge;
